module.exports = __webpack_public_path__ + "static/media/11.217a07ab.jpg";